import { styled, Theme } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import theme from "theme";

interface TurquoiseInfoBoxProps {
  whiteBackground?: boolean;
  noBorder?: boolean;
}

const BackgroundBox = styled(Box)<Theme, TurquoiseInfoBoxProps>(({ whiteBackground, noBorder }) => ({
  backgroundColor: whiteBackground ? "white" : theme.palette.turquoise.light,
  color: theme.palette.turquoise.main,
  border: noBorder ? undefined : `solid 1px`,
  borderRadius: "12px",
}));

export default BackgroundBox;
